<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yeFW9v/tc-custom/9780830893850.jpg?1696024362017" alt="This image is the cover for the book Esther, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Esther, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>The place: Persia. The time: fifth-century BC. The Jews were threatened with genocide. A decree ordered the extermination of young and old, women and children. The book of Esther describes how this crisis was averted through the bravery of Esther, the wisdom of Mordecai and the unity of the Jewish people. Debra Reid's approachable commentary helps us see even more clearly in the book of Esther the God who quietly --and sometimes unexpectedly-- works behind the scenes to order the events of our lives. This completely new volume replaces the previous editon of Esther in the Tyndale Commentary series written by Joyce Baldwin.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debra Reid
      </h2>
      
      <p class="authorDescription body article"><p>Debra Reid is director of open learning at Spurgeon?s College, London. She is the author of <em>Ruth and Esther</em> and <em>Psalms 73-150</em> in the Crossway Bible Guides, a contributor to several reference works, and has been involved in the publication of a variety of Bible editions and new translations.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fce329a6